<template>
  <article class="service">
    <h3 class="service__title title is-2">{{ name }}</h3>
    <p class="service__location is-small" v-if="location">{{ displayedLocation[location] }}</p>
    <div class="service__text rich-text" v-html="description"></div>
    <h4 class="service__contact title is-3" v-if="contact">Contact</h4>
    <div class="service__text rich-text" v-if="contact" v-html="contact"></div>
    <a :href="url" class="service__link" v-if="url">
      <span class="icon icon--external"><external-link-svg></external-link-svg></span>
      <span>Visit Website</span>
    </a>
    <p class="service__tags is-small" v-if="tags.length > 0">
      Tags:&nbsp;
      <ul>
        <li v-for="(tag, idx) in tags" :key="tag">
          {{ tag }}<template v-if="idx < (tags.length - 1)">,&nbsp;</template>
        </li>
      </ul>
    </p>
  </article>
</template>

<script>
import ExternalLinkSvg from '../svg/external-link.vue';

export default {
  name: 'service',
  components: { ExternalLinkSvg },
  props: ['name', 'location', 'description', 'contact', 'url', 'service_type', 'tags'],
  computed: {
    /**
     * Get display location.
     */
    displayedLocation() {
      return {
        national: 'Australia',
        act: 'ACT, Australia',
        nsw: 'NSW, Australia',
        nt: 'NT, Australia',
        qld: 'QLD, Australia',
        sa: 'SA, Australia',
        tas: 'TAS, Australia',
        vic: 'VIC, Australia',
        wa: 'WA, Australia',
      };
    },
  },
};
</script>
